/* eslint-disable */
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {EntitiesEntity} from "app/features/Location/types/YextLocationResponseType";
import {
    deleteKey,
    getKey,
    setKey
} from "app/shared/utils/EncryptionUtility";
import {getScheduleIn, StoreTimeValue} from "app/shared/utils/helperFunctions";
import Constants, { SessionStorageKeys } from "app/shared/constants/constants";

const initialState: StoreState = {
    selectedStore: getKey('selectedStore')? JSON.parse(<string>getKey('selectedStore')): null,
    storeNumber:getKey('storeNumber') ||'',
    storeDescription: getKey('storeDescription') || Constants.NO_LOCATION_SELECTED,
    storePhoneNumber:"",
    pickUpType: getKey('selectedStore') ? getKey('pickUpType') || Constants.NO_PICKUP_TYPE : Constants.NO_PICKUP_TYPE,
    isClosed: false,
    start:"",
    end: "",
    pickUpDate: getKey('selectedStore') ? getKey('pickUpDate') || Constants.NOW : Constants.NOW,
    scheduleIn: getScheduleIn(),
    storeId:"",
    isStoreClosed: getKey('isStoreClosed') ?  JSON.parse(<string>getKey('isStoreClosed')) : false ,
    isStoreEligible: getKey('isStoreEligible') ?  JSON.parse(<string>getKey('isStoreEligible')) : false ,
    pickUpTime: getKey('selectedStore') ? getKey('pickUpTime') || Constants.NO_PICKUP_TIME : Constants.NO_PICKUP_TIME,
    showChangePickUpDetailsModal: false,
    timezone: getKey('timezone')? JSON.parse(`"${getKey('timezone')}"`): '',
    tRestaurantId: getKey('tStoreId') ? getKey('tStoreId') : null,
};

export interface StoreState {
    selectedStore: EntitiesEntity | null,
    storeNumber: string;
    storeDescription: string;
    storePhoneNumber: string;
    pickUpType: string;
    isClosed: boolean;
    start: string;
    end: string;
    pickUpDate: string;
    scheduleIn: number;
    storeId: string;
    isStoreClosed: boolean;
    isStoreEligible: boolean;
    pickUpTime: string;
    showChangePickUpDetailsModal: boolean;
    timezone: string;
    tRestaurantId: string | null;
}


export const storeSlice = createSlice({
    name: 'storeChange',
    initialState,
    reducers: {
        selectStore: (state, action: PayloadAction<EntitiesEntity>) => {
            state.selectedStore = action.payload;
            state.storeNumber = action.payload.meta.id;
            state.storeDescription = action.payload.c_storeDescription;
            state.storePhoneNumber = action.payload.mainPhone;
            state.timezone = action.payload.timezone;
            state.tRestaurantId = action.payload.c_toastRestaurantId || null;
            setKey('tStoreId', action.payload.c_toastRestaurantId || "");
            setKey('selectedStore',JSON.stringify(action.payload));
            setKey('storeNumber', action.payload.meta.id);
            setKey('storeDescription', action.payload.c_storeDescription);
            setKey('timezone', action.payload.timezone);
        },
        selectPickUpType: (state, action: PayloadAction<string>) => {
            state.pickUpType = action.payload;
            setKey('pickUpType', action.payload);
        },
        updateStoreHours: (state, action:PayloadAction<StoreTimeValue>) =>{
            state.isClosed = action.payload.isClosed;
            state.start = action.payload.start;
            state.end = action.payload.end;
        },
        updatePickUpDate: (state, action: PayloadAction<{ pickupDate: string, scheduleIn: number }>) => {
            const { pickupDate, scheduleIn } = action.payload;
            state.pickUpDate = pickupDate;
            const validScheduleIn = Number.isFinite(scheduleIn) ? scheduleIn : 0;
            state.scheduleIn = validScheduleIn;
            setKey(SessionStorageKeys.PICK_UP_DATE, pickupDate);
            setKey(SessionStorageKeys.SCHEDULE_IN, String(validScheduleIn));
        },
        resetStore: () => {
            deleteKey("selectedStore")
            deleteKey("storeNumber")
            deleteKey("storeDescription")
            deleteKey("pickUpType")
            deleteKey("pickUpTime")
            deleteKey(SessionStorageKeys.SCHEDULE_IN)
            deleteKey(SessionStorageKeys.PICK_UP_DATE)
            deleteKey("isStoreClosed")
            deleteKey("isStoreEligible")
            deleteKey("timezone")
            return {...initialState,
                selectedStore: null,
                storeNumber: '',
                storeDescription: Constants.NO_LOCATION_SELECTED,
                pickUpType: Constants.NO_PICKUP_TYPE,
                isStoreClosed: false ,
                isStoreEligible: false ,
                pickUpTime: Constants.NO_PICKUP_TIME,
                pickUpDate: Constants.NOW,
                timezone: '',
            };
        },
        saveStoreID :(state, action:PayloadAction<{ storeId: string }>) =>{
            state.storeId= action.payload.storeId;
        },
        updateStoreStatus: (state, action: PayloadAction<boolean>) => {
            state.isStoreClosed = action.payload;
            setKey('isStoreClosed', JSON.stringify(action.payload));
        },
        updateStoreEligibility: (state, action: PayloadAction<boolean>) => {
            state.isStoreEligible = action.payload;
            setKey('isStoreEligible', JSON.stringify(action.payload));
        },
        updatePickUpTime :(state, action:PayloadAction<{ pickupTime: string }>) =>{
            state.pickUpTime= action.payload.pickupTime;
            setKey('pickUpTime', action.payload.pickupTime);
        },
        updateShowChangePickUpDetailsModal: (state, action: PayloadAction<boolean>) => {
            state.showChangePickUpDetailsModal = action.payload;
        },
        resetPickUpTypeAndTime: (state) => {
            state.pickUpTime = "";
            state.pickUpType = "";
            state.pickUpDate = Constants.NOW;
            deleteKey("pickUpType")
            deleteKey("pickUpTime")
            deleteKey(SessionStorageKeys.PICK_UP_DATE)
            deleteKey(SessionStorageKeys.SCHEDULE_IN)
        },
    },
});

export default storeSlice.reducer;

// export methods
export const {
    selectStore,
    selectPickUpType,
    resetStore,
    updateStoreHours,
    updatePickUpDate,
    saveStoreID,
    updateStoreStatus,
    updatePickUpTime,
    updateShowChangePickUpDetailsModal,
    updateStoreEligibility,
    resetPickUpTypeAndTime,
} = storeSlice.actions;
